<!-- My Account Section -->
<section class="my-account-section" *ngIf="isLoggedIn">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-header text-center mb-5">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="section-title">Proxmox Dashboard</h1>
              <p class="section-description">Manage your virtual environment</p>
            </div>
            <button class="btn btn-outline-danger" (click)="onLogout()">
              <i class="bx bx-log-out"></i> Logout
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Stats Cards -->
      <div class="col-lg-12 mb-4">
        <div class="dashboard-card">
          <h2 class="card-title">Cluster Overview</h2>
          <div class="row">
            <div class="col-md-4">
              <div class="stat-card text-center">
                <div class="stat-icon mx-auto mb-2">
                  <i class="bx bx-server"></i>
                </div>
                <h3 class="stat-number">{{ vms.length }}</h3>
                <p class="stat-label">Virtual Machines</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stat-card text-center">
                <div class="stat-icon mx-auto mb-2">
                  <i class="bx bx-data"></i>
                </div>
                <h3 class="stat-number">{{ nodes.length }}</h3>
                <p class="stat-label">Nodes</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stat-card text-center">
                <div class="stat-icon mx-auto mb-2">
                  <i class="bx bx-memory-card"></i>
                </div>
                <h3 class="stat-number">0</h3>
                <p class="stat-label">Storage Used</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Nodes Section -->
      <div class="col-lg-12 mb-4">
        <div class="services-card">
          <h2 class="card-title">Nodes</h2>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Node</th>
                  <th>Status</th>
                  <th>CPU</th>
                  <th>Memory</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let node of nodes">
                  <td>{{ node.node }}</td>
                  <td>
                    <span class="badge" [ngClass]="{'bg-success': node.status === 'online', 'bg-danger': node.status !== 'online'}">
                      {{ node.status }}
                    </span>
                  </td>
                  <td>{{ node.cpu ? (node.cpu * 100).toFixed(1) + '%' : 'N/A' }}</td>
                  <td>{{ node.mem ? formatBytes(node.mem) : 'N/A' }}</td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary">View</button>
                  </td>
                </tr>
                <tr *ngIf="nodes.length === 0">
                  <td colspan="5" class="text-center">No nodes found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- VMs Section -->
      <div class="col-lg-12">
        <div class="services-card">
          <h2 class="card-title">Virtual Machines</h2>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Node</th>
                  <th>Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let vm of vms">
                  <td>{{ vm.vmid }}</td>
                  <td>{{ vm.name }}</td>
                  <td>
                    <span class="badge" [ngClass]="{'bg-success': vm.status === 'running', 'bg-warning': vm.status === 'stopped', 'bg-secondary': vm.status === 'unknown'}">
                      {{ vm.status }}
                    </span>
                  </td>
                  <td>{{ vm.node }}</td>
                  <td>{{ vm.type }}</td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary me-1">Start</button>
                    <button class="btn btn-sm btn-outline-danger">Stop</button>
                  </td>
                </tr>
                <tr *ngIf="vms.length === 0">
                  <td colspan="6" class="text-center">No virtual machines found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Login Redirect Section -->
<section class="my-account-section" *ngIf="!isLoggedIn">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8">
        <div class="section-header text-center mb-5">
          <h1 class="section-title">Access Required</h1>
          <p class="section-description">Please log in to access your account</p>
        </div>
        <div class="text-center">
          <button class="btn btn-primary" routerLink="/log-in">Go to Login</button>
        </div>
      </div>
    </div>
  </div>
</section>
